import { LoadState } from "../../constants/enums";
import { IPaymentType, IPaymentTypeState } from "./paymentType";



export const defaultPaymentType: IPaymentType = {
    payment_mode: "",
    total_fee: "",
}

export const defaultPaymentTypeState: IPaymentTypeState = {
    list: {
        data: [],
        loading: LoadState.NotLoaded,
        error: null,
    },
    paymenttype: {
        data: defaultPaymentType,
        loading: LoadState.NotLoaded,
        error: null,
    },
}